
    var riot = require('riot')
    //src: starling/src/tags/menu/toolbar-view-more-menu.html
riot.tag2('toolbar-view-more-menu',
  '<div class="floating-menu_list bulk-menu"> <section class="bulk-menu_section bulk-menu_section--card-options"> <menu-item-create-region-from-selection if="{showCardOptions()}" canvas="{canvas}" onmouseenter="{delayedHideSubMenus}"></menu-item-create-region-from-selection> <menu-item-create-waypoint if="{canvas.isFeatureEnabled(\'presentation\') && showCardOptions()}" onmouseenter="{delayedHideSubMenus}"></menu-item-create-waypoint> <menu-item-link-to-selection if="{showCardOptions()}" onmouseenter="{delayedHideSubMenus}"></menu-item-link-to-selection> <menu-item-export if="{showCardOptions()}"></menu-item-export> <menu-item-duplicate if="{showCardOptions()}" onmouseenter="{delayedHideSubMenus}"></menu-item-duplicate> </section> <section class="bulk-menu_section bulk-menu_section--group-options"> <div if="{showCardOptions() && (showUngroupSystem() || showDetachPart() || showDetachRelationshipCard() || (canvas.isFeatureEnabled(\'attributes\') && canvas.selectedElements.length))}" class="floating-menu_divider"></div> <menu-item-ungroup-system if="{showUngroupSystem()}" onmouseenter="{delayedHideSubMenus}"></menu-item-ungroup-system> <menu-item-detach-part if="{showDetachPart()}" onmouseenter="{delayedHideSubMenus}"></menu-item-detach-part> <menu-item-detach-relationship-card if="{showDetachRelationshipCard()}" onmouseenter="{delayedHideSubMenus}"></menu-item-detach-relationship-card> <menu-item-attribute-editor if="{canvas.isFeatureEnabled(\'attributes\') && showCardOptions() && canvas.selectedElements.length}"></menu-item-attribute-editor> </section> <section class="bulk-menu_section bulk-menu_section--part-options"> <div if="{showCardOptions() && (showPartOptions() || (showPopOut() || showPopIn()) || canvas.selectedElements.length === 1)}" class="floating-menu_divider"></div> <menu-item-layout if="{showPartOptions()}"></menu-item-layout> <menu-item-pop-parts if="{showPartOptions() && (showPopOut() || showPopIn())}" inorout="{showPopIn() ? \'in\' : \'out\'}" onmouseenter="{delayedHideSubMenus}"></menu-item-pop-parts> <menu-item-images if="{showCardOptions() && canvas.selectedElements.length === 1}" onmouseenter="{delayedHideSubMenus}"></menu-item-images> </section> <section class="bulk-menu_section bulk-menu_section--relationship-options"> <div if="{showRelationshipOptions()}" class="floating-menu_divider"></div> <menu-item-straighten-line onmouseenter="{delayedHideSubMenus}"></menu-item-straighten-line> <menu-item-link-direction></menu-item-link-direction> </section> </div>',
  '',
  'if="{!canvas.isViewOnly()}" class="floating-menu {floating-menu--hidden: !isOpen} toolbar-view-more-menu--{getToolbarTargetClass()}" riot-style="{getStyle()}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants.js');

var _appUi = require('lib/app-ui');

var _toolbarUi = require('lib/toolbar-ui');

var _menuUi = require('lib/menu-ui');

var _delayHandler = require('lib/delay-handler');

var canvas = opts.canvas;
var self = this;
this.canvas = canvas;
canvas.toolbarViewMoreMenu = this;
this.isBulkMenu = true;
this.isOpen = false;
this.menuName = 'view-more-menu';

this.summon = function (_ref) {
  var referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft;

  var rect = referenceEl.getBoundingClientRect();
  canvas.hidePopups();

  canvas.bulkActionsMenuTag.setViewMoreActive();

  _this.isOpen = true;
  _this.positionToLeft = positionToLeft;
  _this.root.classList.remove('hidden');
  _this.y = rect.bottom;
  _this.x = rect.left;
  _this.style = 'top: ' + (_this.y + 4) + 'px; left: ' + _this.x + 'px';
  //account for margin...
  if (_this.positionToLeft) {
    _this.style = 'top: ' + (_this.y + 4) + 'px; right: ' + (window.innerWidth - rect.left) + 'px';
  }

  _this.update();
  _this.isOpen = true;
  _this.positionSubToLeft = _appUi.appUI.positionSubMenuToLeft({
    positionReferenceElement: _this.root
  });
};

this.getStyle = function () {
  return _this.style;
};

this.hideTagsMenus = function () {
  var tags = _this.tags;

  if (tags['menu-item-relationship-style']) tags['menu-item-relationship-style'].hideSubMenu();
  if (tags['menu-item-card-style']) tags['menu-item-card-style'].hideSubMenu();
  if (tags['menu-item-link-curvature']) tags['menu-item-link-curvature'].hide();
};

this.hide = function () {
  _this.isOpen = false;
  _this.hideTagsMenus();
  _this.update();
  _this.root.classList.add('hidden');
};

this.canvasIsEmpty = function () {
  return canvas.store.getNodesSize() === 0;
};

this.createNode = function (e) {
  e.stopPropagation();
  e.preventDefault();
  canvas.createNodeOnDblClick(e);
  _this.hide();
};

this.delayedHideSubMenus = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function (e) {
  canvas.nodeLayoutMenuTag.hide();
  canvas.nodePerspectivesPanelTag.hide();
  canvas.nodeAlignmentPanelTag.hide();
  canvas.exportMenu.hide();
  canvas.linkDirectionMenu.hide();
  canvas.nodeAttributeEditor.hide();
  _this.perspectiveColorPickerVisible = false;

  _this.hideTagsMenus();
  _this.update();
};

// return the list of node ids that the current right click menu will operate on
this.getSelectedNodeIds = function () {
  return canvas.getSelectedNodes().map(function (n) {
    return n.id;
  });
};

this.getSelectedLinkIds = function () {
  if (canvas.getSelectedLinks().length) {
    return canvas.getSelectedLinks().map(function (l) {
      return l.id;
    });
  }
};

this.showArrangeOption = function () {
  // TODO: update me
  if (canvas.getSelectedNodes().length > 1) {
    return true;
  }
};

this.showCardOptions = function () {
  if (canvas.getSelectedNodes().length) {
    return true;
  }
};

this.showPopIn = _menuUi.mui.showPopIn.bind(this);
this.showPopOut = _menuUi.mui.showPopOut.bind(this);

this.showGroupSelection = function () {
  if (canvas.getSelectedNodes().length > 1) {
    return true;
  }
  return false;
};

this.showDetachRelationshipCard = function () {
  return _toolbarUi.tui.showDetachRelationshipCard();
};

this.showDetachPart = function () {
  if (canvas.getSelectedNodes().length == 0) return false;
  if (canvas.getSelectedNodes().some(function (n) {
    return n.parentId;
  })) return true;
  return false;
};

this.showUngroupSystem = function () {
  if (canvas.getSelectedNodes().length == 0) return false;
  if (canvas.getSelectedNodes().some(function (n) {
    return n.children().length;
  })) return true;
  return false;
};

this.showPartOptions = function () {
  return _toolbarUi.tui.showPartOptions();
};

this.showRelationshipOptions = function () {
  if (canvas.getSelectedLinks().length) {
    return true;
  }
  return false;
};

/* only one card selected */
this.isCardTarget = function () {
  return _toolbarUi.tui.isCardTarget();
};

/* only two cards selected */
this.isTwoCardTarget = function () {
  return _toolbarUi.tui.isTwoCardTarget();
};

/* only one top level card with parts selected */
this.isSystemTarget = function () {
  return _toolbarUi.tui.isSystemTarget();
};

/* parts or R cards selected */
this.isAttachedCardTarget = function () {
  return _toolbarUi.tui.isAttachedCardTarget();
};

/* only relationships selected */
this.isRelationshipTarget = function () {
  return _toolbarUi.tui.isRelationshipTarget();
};

/* multiple cards and 1 or more relationships */
this.isMixedSelectionTarget = function () {
  return _toolbarUi.tui.isMixedSelectionTarget();
};

this.getToolbarTargetClass = function () {
  return _toolbarUi.tui.getToolbarTargetClass();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('toolbar-view-more-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/toolbar-view-more-menu.html
// module id = 681
// module chunks = 0